"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountRoleToJSON = exports.AdAccountRoleFromJSONTyped = exports.AdAccountRoleFromJSON = exports.AdAccountRole = void 0;
/**
 * The role of a user in an ad account.
 * @export
 */
exports.AdAccountRole = {
    Admin: 'AD_ACCOUNT_ADMIN',
    Contributor: 'AD_ACCOUNT_CONTRIBUTOR',
    Viewer: 'AD_ACCOUNT_VIEWER'
};
function AdAccountRoleFromJSON(json) {
    return AdAccountRoleFromJSONTyped(json, false);
}
exports.AdAccountRoleFromJSON = AdAccountRoleFromJSON;
function AdAccountRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdAccountRoleFromJSONTyped = AdAccountRoleFromJSONTyped;
function AdAccountRoleToJSON(value) {
    return value;
}
exports.AdAccountRoleToJSON = AdAccountRoleToJSON;
